import React from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import { useTranslation } from "react-i18next";

export default function InsightInvitePartnerSentModal({ onClose }) {
  const { t } = useTranslation();
  return (
    <BaseModal
      onClose={onClose}
      description={t("insight_questionnaire_form_page.invite_partner_sent")}
      eventTypeModal={MODAL_TYPES.INSIGHT_INVITE_PARTNER_SENT}
    />
  );
}
